export class StatisticProfitLossDto {

  public readonly invoiceSumNetAmount!: number;
  public readonly receiptSumNetAmount!: number;
  public readonly balance!: number;
  public readonly digits!: number;
  public readonly currencyCode!: string; // Enum: AccCurrency
  public readonly month!: number;
  public readonly year!: number;

  constructor(init?: Partial<StatisticProfitLossDto> | undefined) {
    Object.assign(this, init);
  }
}
